import { getUriParams } from '../../../helpers';
import {
  CORE, gateway,
} from '../../api';

export function findClienteByNumProcesso(numProcesso) {
  return gateway.get(`${CORE}/manutencao/cliente-atual/${numProcesso}`);
}

// Contrato assumido (endpoint ainda não confirmado com o backend): "código do cliente novo"
// é tratado como equivalente ao idCliente usado por findSimpleCliente (ver plano AW2-359).
export function updateClienteDoProcesso(numProcesso, codigoClienteNovo, recalcularValor, justificativa) {
  const uri = getUriParams({ recalcularValor: recalcularValor === 'S', justificativa });
  return gateway.put(`${CORE}/manutencao/atualizar-cliente/${numProcesso}/${codigoClienteNovo}?${uri}`);
}
